export const enData = `
  <div class="paragraph">
    <div class="text-box">
      <div class="text">Last updated: 25th May 2026</div>
      <div class="text">To help you understand how we process your personal data, we have prepared a brief summary of our Privacy Notice. For more details, please see the full version of the Privacy Notice below. We recommend that you also read the full version of the Privacy Notice so that you fully understand how we handle your personal data and what options and rights you have in relation to your personal data.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Key Points</div>
  </div>
  <div class="paragraph">
    <div class="title">Who is responsible for collecting and using your data?</div>
    <div class="text-box">
      <div class="text">Generally, Danghuan is responsible for collecting and using your personal data. To the extent you are located in Europe, the controller of your personal data is Danghuan Europe S.L.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Data we use</div>
    <div class="text-box">
      <div class="text">We process data that you directly provide to us or that we collect when you use our Services. We may also receive personal data about you from third parties and partner platforms.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What we use it for</div>
    <div class="text-box">
      <div class="text">We use your personal data only where we have a lawful basis to do so, including the performance of a contract, compliance with legal obligations, our legitimate interests, or your consent.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">How long we keep your data</div>
    <div class="text-box">
      <div class="text">We do not keep your personal data longer than necessary for the purposes described in this Privacy Notice unless required by law.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Marketing</div>
    <div class="text-box">
      <div class="text">We may send you information about our Services or offers that may interest you. Where required by law, we will do so only with your consent.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Sharing your personal data</div>
    <div class="text-box">
      <div class="text">We may share your personal data with affiliated companies, logistics providers, payment partners, platform partners, and service providers where necessary to provide our Services or comply with legal obligations.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Security</div>
    <div class="text-box">
      <div class="text">We implement technical and organizational measures to protect your personal data.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Your rights</div>
    <div class="text-box">
      <div class="text">Depending on applicable law, you may have rights to access, correct, delete, restrict, or object to the processing of your personal data.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Children</div>
    <div class="text-box">
      <div class="text">Our Services are intended for users who are at least 18 years old.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">International transfer</div>
    <div class="text-box">
      <div class="text">Your personal data may be transferred internationally with appropriate safeguards in place.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Updates</div>
    <div class="text-box">
      <div class="text">We may update this Privacy Notice from time to time.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Contact us</div>
    <div class="text-box">
      <div class="text">If you have questions, you can contact us at <span class="email">privacy@danghuan.eu</span></div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Privacy Notice</div>
    <div class="text-box">
      <div class="text">This Privacy Notice describes how Danghuan Europe S.L. and its affiliated companies (“Danghuan”, “we”, “us” or “our”) collect, use, disclose, transfer, store and otherwise process your personal data when you use our services, including our websites, buyback services, resale services, logistics services, online platforms and other related services (collectively referred to as the “Services”).</div>
      <div class="text">Please read this Privacy Notice carefully and familiarize yourself with our privacy practices before using our Services or providing your personal data.</div>
      <div class="text">In addition to this Privacy Notice, specific privacy notices may apply depending on the Services used. We will, where applicable, provide you with the relevant additional notice.</div>
      <div class="text">The general provisions of Section A apply regardless of your location. Section B only applies to customers located in the European Union, Liechtenstein, Norway, the United Kingdom or Switzerland (“Europe”).</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">A. General Provisions</div>
    <div class="text-box">

    </div>
  </div>
  <div class="paragraph">
    <div class="title">I. Responsibilities</div>
    <div class="text-box">
      <div class="text">We operate and offer our Services globally. However, our Services may differ depending on where you live.</div>
      <div class="text">• Danghuan Europe S.L. as Controller: If you live in Europe, Danghuan Europe S.L. is responsible for the processing of your personal data as described in this Privacy Notice.</div>
      <div class="text">• In general, Danghuan is responsible for and controls the processing of your personal data with respect to personal data collected through the Services outside Europe and is committed to protecting and respecting your privacy.</div>
      <div class="text">The terms “Danghuan”, “we” and “us” therefore refer to Danghuan Europe S.L. or the relevant affiliated entity depending on your location.</div>
      <div class="text">Please note that, in relation to logistics, payment processing, after-sales services or partner platform transactions, certain authorized partners or third-party providers may independently process your personal data in connection with the services they provide to you.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">II. How We Collect Personal Data and What Types of Personal Data We Collect</div>
    <div class="text-box">
      <div class="text">The term “personal data” means any information relating to an identified or identifiable individual.</div>
      <div class="text">Our channels for collecting personal data include:</div>
      <div class="text">• personal data that you provide directly to us;</div>
      <div class="text">• personal data automatically collected when you interact with our Services;</div>
      <div class="text">• personal data obtained from third parties or partner platforms.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">1. Personal Data Directly Provided by You</div>
    <div class="text-box">
      <div class="text">You may provide personal data directly to us. However, if certain personal data is required to provide our Services and you choose not to provide it, we may not be able to provide the requested Services.</div>
      <div class="text">Personal data we may collect directly from you includes:</div>
      <div class="text">• your name, address, email address and phone number;</div>
      <div class="text">• billing and shipping information;</div>
      <div class="text">• IBAN, bank account details, PayPal, Revolut or other payment information;</div>
      <div class="text">• device information such as brand, model, IMEI, serial number, condition and valuation details;</div>
      <div class="text">• transaction history, refund requests, return requests and communication records;</div>
      <div class="text">• customer support communications;</div>
      <div class="text">• information submitted through surveys, campaigns, promotions or competitions;</div>
      <div class="text">• marketing preferences and newsletter subscriptions.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">2. Personal Data We Automatically Collect</div>
    <div class="text-box">
      <div class="text">In addition to personal data provided by you, we may automatically collect information relating to your use of our Services, including:</div>
      <div class="text">• IP address;</div>
      <div class="text">• browser type and version;</div>
      <div class="text">• operating system;</div>
      <div class="text">• session identifiers;</div>
      <div class="text">• device identifiers;</div>
      <div class="text">• geolocation information;</div>
      <div class="text">• website interaction data;</div>
      <div class="text">• pages visited and browsing behavior;</div>
      <div class="text">• log information;</div>
      <div class="text">• cookies and tracking information.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">3. Personal Data We Obtain from Third Parties</div>
    <div class="text-box">
      <div class="text">We may obtain personal data from:</div>
      <div class="text">• Shopify;</div>
      <div class="text">• Amazon;</div>
      <div class="text">• TEMU;</div>
      <div class="text">• Back Market;</div>
      <div class="text">• payment providers;</div>
      <div class="text">• logistics providers;</div>
      <div class="text">• anti-fraud service providers;</div>
      <div class="text">• marketing and analytics partners;</div>
      <div class="text">• public databases where permitted by law.</div>
      <div class="text">This may include order information, shipping details, transaction confirmations, and fraud prevention information.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">4. Non-personal Data</div>
    <div class="text-box">
      <div class="text">We may process aggregated or anonymized information that does not identify you directly.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">III. How We Use Your Personal Data</div>
    <div class="text-box">
      <div class="text">We use your personal data for the following purposes:</div>
      <div class="text">• to provide our Services;</div>
      <div class="text">• to process buyback, resale, payment, shipping, return and refund transactions;</div>
      <div class="text">• to arrange logistics and deliveries;</div>
      <div class="text">• to verify device information and ownership;</div>
      <div class="text">• to communicate with you regarding your transactions or support requests;</div>
      <div class="text">• to provide customer service;</div>
      <div class="text">• to improve our Services and user experience;</div>
      <div class="text">• to conduct fraud prevention and risk analysis;</div>
      <div class="text">• to conduct internal analytics and business operations;</div>
      <div class="text">• to send marketing communications where permitted;</div>
      <div class="text">• to manage promotions, campaigns and competitions;</div>
      <div class="text">• to comply with legal obligations;</div>
      <div class="text">• to pursue or defend legal claims.</div>
      <div class="text">We do not make decisions based solely on automated processing that produce legal or similarly significant effects on you.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">IV. How We Use Cookies and Similar Technologies</div>
    <div class="text-box">
      <div class="text">We use cookies and similar technologies on our websites and Services.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">1. What Are Cookies?</div>
    <div class="text-box">
      <div class="text">Cookies are small text files stored on your device.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">2. How We Use Cookies</div>
    <div class="text-box">
      <div class="text">We use cookies to:</div>
      <div class="text">• operate our Services;</div>
      <div class="text">• remember user preferences;</div>
      <div class="text">• analyse website traffic;</div>
      <div class="text">• improve website functionality;</div>
      <div class="text">• personalize content and advertisements;</div>
      <div class="text">• measure advertising effectiveness.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">3. Types of Data We Collect Through Cookies</div>
    <div class="text-box">
      <div class="text">This may include:</div>
      <div class="text">• IP addresses;</div>
      <div class="text">• browser type;</div>
      <div class="text">• operating system;</div>
      <div class="text">• pages visited;</div>
      <div class="text">• session data;</div>
      <div class="text">• click behavior;</div>
      <div class="text">• location information.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">4. Third-Party Tracking and Advertising</div>
    <div class="text-box">
      <div class="text">We may work with third-party partners such as Google, Meta, TikTok and other analytics or advertising providers.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">5. Managing Cookies</div>
    <div class="text-box">
      <div class="text">You may manage or disable cookies through your browser settings or cookie banner preferences.</div>

      <div class="text">Examples of cookies we may use:</div>
      <div class="text">
        <table>
          <thead>
            <tr>
              <th>Category</th>
              <th>Name</th>
              <th>Provider</th>
              <th>Purpose</th>
              <th>Duration</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>Strictly Necessary</td><td>session_id</td><td>danghuan.eu</td><td>User session management</td><td>Session</td><td>First-party</td></tr>
            <tr><td>Functional</td><td>language_pref</td><td>danghuan.eu</td><td>Remember language preference</td><td>1 year</td><td>First-party</td></tr>
            <tr><td>Performance</td><td>_ga</td><td>Google Analytics</td><td>Website analytics</td><td>2 years</td><td>Third-party</td></tr>
            <tr><td>Advertising</td><td>_fbp</td><td>Meta</td><td>Advertising measurement</td><td>3 months</td><td>Third-party</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">V. How Long We Keep Your Personal Data</div>
    <div class="text-box">
      <div class="text">We retain your personal data only as long as necessary for the purposes described in this Privacy Notice unless a longer retention period is required by law.</div>
      <div class="text">After the applicable retention period expires, we will delete or anonymize your personal data.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">VI. How We Disclose Your Personal Data</div>
    <div class="text-box">
      <div class="text">We may disclose your personal data to:</div>
      <div class="text">• affiliated companies;</div>
      <div class="text">• payment providers such as PayPal, Revolut, VISA, Mastercard and Stripe;</div>
      <div class="text">• logistics providers such as UPS, Correos, DPD, Royal Mail, NACEX and FedEx;</div>
      <div class="text">• platform partners such as Shopify, Amazon, TEMU and Back Market;</div>
      <div class="text">• marketing and analytics providers;</div>
      <div class="text">• professional advisers and IT providers;</div>
      <div class="text">• government authorities and regulators where required by law.</div>
      <div class="text">We do not sell your personal data to third parties.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">VII. International Transfers of Personal Data</div>
    <div class="text-box">
      <div class="text">Your personal data may be transferred to and processed in countries outside your jurisdiction.</div>
      <div class="text">Where required by law, we implement appropriate safeguards including:</div>
      <div class="text">• Standard Contractual Clauses;</div>
      <div class="text">• adequacy decisions;</div>
      <div class="text">• legally recognized transfer mechanisms.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">VIII. How We Protect Your Personal Data</div>
    <div class="text-box">
      <div class="text">We implement technical and organizational security measures including:</div>
      <div class="text">• encryption;</div>
      <div class="text">• secure storage;</div>
      <div class="text">• access controls;</div>
      <div class="text">• authentication procedures;</div>
      <div class="text">• internal confidentiality obligations;</div>
      <div class="text">• fraud monitoring;</div>
      <div class="text">• secure transmission methods.</div>
      <div class="text">However, no transmission or storage system is completely secure.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">IX. Your Rights Regarding Your Personal Data</div>
    <div class="text-box">
      <div class="text">Depending on applicable law, you may have the following rights:</div>
      <div class="text">• the right to access your personal data;</div>
      <div class="text">• the right to rectify inaccurate data;</div>
      <div class="text">• the right to erase your personal data;</div>
      <div class="text">• the right to restrict processing;</div>
      <div class="text">• the right to object to processing;</div>
      <div class="text">• the right to data portability;</div>
      <div class="text">• the right to withdraw consent;</div>
      <div class="text">• the right to lodge a complaint with a supervisory authority.</div>
      <div class="text">You may exercise your rights by contacting: <span class="email">privacy@danghuan.eu</span></div>
      <div class="text">We may require identity verification before processing your request.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">X. How We Process Children’s Personal Data</div>
    <div class="text-box">
      <div class="text">Our Services are intended for adults aged 18 years or older.</div>
      <div class="text">If we discover that we have collected personal data relating to a child without appropriate consent, we will delete it as soon as possible.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">XI. Third-Party Websites</div>
    <div class="text-box">
      <div class="text">Our Services may contain links to third-party websites, platforms, or services.</div>
      <div class="text">We are not responsible for the privacy practices of third parties.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">XII. Use of Third-Party Brand Names and Logos</div>
    <div class="text-box">
      <div class="text">Our website may display brand names and logos such as Apple, Samsung, OPPO, OnePlus, vivo, Xiaomi, Google, and others solely to identify devices compatible with our Services.</div>
      <div class="text">All trademarks belong to their respective owners.</div>
      <div class="text">Danghuan is an independent service provider and is not affiliated with or endorsed by those brands unless expressly stated.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">XIII. Updates to This Privacy Notice</div>
    <div class="text-box">
      <div class="text">We reserve the right to update this Privacy Notice from time to time.</div>
      <div class="text">The latest version will always be available on our website.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">B. GDPR-Specific Provisions</div>
    <div class="text-box">
      <div class="text">The following provisions apply only if you are in Europe.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">I. Legal Bases for Processing</div>
    <div class="text-box">
      <div class="text">We process your personal data based on:</div>
      <div class="text">• your consent;</div>
      <div class="text">• performance of a contract;</div>
      <div class="text">• compliance with legal obligations;</div>
      <div class="text">• legitimate interests.</div>
      <div class="text">Our legitimate interests may include:</div>
      <div class="text">• fraud prevention;</div>
      <div class="text">• service improvement;</div>
      <div class="text">• analytics;</div>
      <div class="text">• customer support;</div>
      <div class="text">• cybersecurity;</div>
      <div class="text">• business administration;</div>
      <div class="text">• legal defense.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">II. Additional Information on International Transfers</div>
    <div class="text-box">
      <div class="text">Where personal data is transferred outside Europe, we ensure appropriate safeguards including:</div>
      <div class="text">• adequacy decisions;</div>
      <div class="text">• Standard Contractual Clauses;</div>
      <div class="text">• other lawful transfer mechanisms.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">III. Additional Information About Cookies</div>
    <div class="text-box">
      <div class="text">Additional cookie information may be provided through our Cookie Policy or cookie banner.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">IV. Additional Information About Your Rights</div>
    <div class="text-box">
      <div class="text">Under the GDPR, you may additionally have:</div>
      <div class="text">• the right to object to processing based on legitimate interests;</div>
      <div class="text">• the right to object to direct marketing;</div>
      <div class="text">• the right to restriction of processing;</div>
      <div class="text">• the right to lodge complaints with supervisory authorities.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">V. Contact Details</div>
    <div class="text-box">
      <div class="text">You may contact us regarding data protection matters at:</div>
      <div class="text">Danghuan Europe S.L.</div>
      <div class="text">Email: <span class="email">privacy@danghuan.eu</span></div>
      <div class="text">Website: <a href="https://www.danghuan.eu" target="_blank">https://www.danghuan.eu</a></div>
      <div class="text">You may also lodge a complaint with your local data protection authority.</div>
    </div>
  </div>
`;
